// extracted by mini-css-extract-plugin
module.exports = {"categories":"home_categories__3peDO","wrapIcon":"home_wrapIcon__2HUoJ"};